declare global {
  interface Window {
    confirmModalPromise: (message: string) => Promise<boolean>;
  }
}

document.addEventListener('DOMContentLoaded', function () {
  bindDeleteConfirmations();
});

function bindDeleteConfirmations() {
  const deleteForms = document.querySelectorAll<HTMLFormElement>('form[data-confirm]');

  deleteForms.forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      confirmModal(
        form.getAttribute('data-confirm') || 'Are you sure you want to continue?',
        () => form.submit(),
        () => {},
        'btn-danger',
      );
    });
  });
}

export function confirmModal(
  message: string = '',
  confirmCallback: CallableFunction = () => {},
  cancelCallback: CallableFunction = () => {},
  confirmButtonClass: string = 'btn-success',
  cancelButtonClass: string = 'btn-secondary',
  confirmButtonText: string = 'Confirm',
  cancelButtonText: string = 'Cancel',
  modalTitle: string = 'Confirm',
) {
  let confirmationModal = document.querySelector('[data-modal="confirmationModal"]');

  confirmationModal = document.createElement('div');
  confirmationModal.setAttribute('data-modal', 'confirmationModal');
  confirmationModal.classList.add('modal', 'fade');
  confirmationModal.innerHTML = `
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title"></h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <span data-confirmation-message></span>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn" data-button="cancelButton"></button>
          <button type="button" class="btn" data-button="confirmButton"></button>
        </div>
      </div>
    </div>
    `;
  document.body.appendChild(confirmationModal);

  const removeModal = () => {
    setTimeout(() => {
      modal.dispose();
      confirmationModal?.remove();
    }, 5000);
  };

  const confirmationMessage = message || 'Are you sure you want to continue?';
  // @ts-ignore
  const modal = new bootstrap.Modal(confirmationModal);
  const confirmButton = confirmationModal.querySelector('[data-button="confirmButton"]');
  const cancelButton = confirmationModal.querySelector('[data-button="cancelButton"]');
  const messageElement = confirmationModal.querySelector('[data-confirmation-message]');
  const modalTitleElement = confirmationModal.querySelector('.modal-title')!;

  if (!message) {
    console.warn('Confirmation modal is missing confirmation message.');
    return;
  }

  if (messageElement) {
    messageElement.innerHTML = confirmationMessage.split('\n').map(escapeHTML).join('<br>');
  }

  if (!confirmButton || !cancelButton) {
    console.warn('Confirmation modal is missing confirm or cancel button.');
    return;
  }

  confirmButton.addEventListener('click', function () {
    modal.hide();
    removeModal();
    confirmCallback();
  });

  confirmButton.classList.add(confirmButtonClass);
  confirmButton.textContent = confirmButtonText;

  cancelButton.classList.add(cancelButtonClass);
  cancelButton.textContent = cancelButtonText;

  modalTitleElement.textContent = modalTitle;

  cancelButton.addEventListener('click', function () {
    modal.hide();
    removeModal();
    cancelCallback();
  });

  modal.show();
}

window.confirmModalPromise = confirmModalPromise;
export function confirmModalPromise(message: string = ''): Promise<boolean> {
  return new Promise(function (resolve, reject) {
    confirmModal(
      message,
      function () {
        resolve(true);
      },
      function () {
        resolve(false);
      },
    );
  });
}

function escapeHTML(unsafe: string) {
  return unsafe.replace(/[\u0000-\u002F\u003A-\u0040\u005B-\u0060\u007B-\u00FF]/g, (c) => '&#' + ('000' + c.charCodeAt(0)).slice(-4) + ';');
}
